/* DEBUG sticky product gallery – STIFF (no bounce) */
(function () {
// OFF on real touch devices OR very small screens
if (
  window.matchMedia('(hover: none) and (pointer: coarse)').matches || // phones/tablets (touch)
  window.matchMedia('(max-width: 767px)').matches                     // small phones by width
) return;



  // kleine statusbadge (optioneel)
  function badge(msg, ok){
    var el = document.getElementById('stickyBadge');
    if(!el){
      el = document.createElement('div');
      el.id = 'stickyBadge';
      el.style.cssText = 'position:fixed;left:10px;bottom:10px;padding:6px 8px;font:12px/1.2 sans-serif;z-index:99999;border-radius:4px;color:#fff';
      document.body.appendChild(el);
    }
    el.style.background = ok ? '#2c7a7b' : '#e11d48';
    el.textContent = 'sticky: ' + msg;
    setTimeout(function(){ el.remove(); }, 2500);
  }

  function init() {
    badge('loaded', true);

    // 1) Gallery zoeken
    var SEL_G = '.product__media, .product__gallery, .product__images, .product-media, .product-gallery, .product-images';
    var g = document.querySelector('.product-page ' + SEL_G) || document.querySelector(SEL_G);
    if(!g){ badge('no gallery', false); return; }

    // 2) Container (grid) zoeken
    var SEL_C = '.float-grid, .product_main_content, .product__inner, .product-inner, .Product__inner';
    var cont = g.closest(SEL_C) || document.querySelector(SEL_C);
    if(!cont){ badge('no container', false); return; }

    // 3) Kolom met de gallery
    var col = Array.from(cont.children).find(function(el){ return el && el.contains(g); }) ||
              g.closest('.grid_item, .Grid__item') || g.parentElement;
    if(!col){ badge('no column', false); return; }

    // === STIFF wijziging: géén translate/rAF, alleen CSS-sticky ===
    col.classList.remove('sticky-translate');
    col.style.transform = '';                 // oude transform weghalen
    cont.style.overflow = 'visible';          // container toestaan
    try {
      var cs = getComputedStyle(cont);
      if (cs.alignItems === 'stretch') cont.style.alignItems = 'flex-start';
    } catch(e){}

    // CSS sticky toepassen (stijf, geen bounce)
    col.style.position = '-webkit-sticky';
    col.style.position = 'sticky';
    col.style.top = '0px';                    // wil je een kleine gap? zet bv. '8px' of '12px'
    col.style.alignSelf = 'flex-start';

    badge('ok (stiff)', true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
